module.exports = __webpack_public_path__ + "static/img/cs2.f6fc82f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/cs2.png
// module id = 304
// module chunks = 34